const ORDER_HISTORY_KEY = "orderHistory";
const LATEST_ORDER_KEY = "latestOrderId";
const DAY_IN_MS = 24 * 60 * 60 * 1000;

const getOrderStatusFromDate = (isoDate) => {
  const ageMs = Date.now() - new Date(isoDate).getTime();

  if (ageMs >= 4 * DAY_IN_MS) {
    return "Delivered";
  }

  if (ageMs >= 2 * DAY_IN_MS) {
    return "Out for delivery";
  }

  if (ageMs >= DAY_IN_MS) {
    return "Shipped";
  }

  if (ageMs >= 3 * 60 * 60 * 1000) {
    return "Order ready";
  }

  return "Processing";
};

const withDerivedOrderData = (order) => ({
  ...order,
  status: getOrderStatusFromDate(order.date),
  estimatedDeliveryDate:
    order.estimatedDeliveryDate ||
    new Date(new Date(order.date).getTime() + 3 * DAY_IN_MS).toISOString(),
});

export const loadOrders = () => {
  try {
    const orders = JSON.parse(localStorage.getItem(ORDER_HISTORY_KEY)) || [];
    return orders.map(withDerivedOrderData);
  } catch {
    return [];
  }
};

export const saveOrders = (orders) => {
  localStorage.setItem(ORDER_HISTORY_KEY, JSON.stringify(orders));
  return orders;
};

const generateInvoiceNumber = () => {
  const year = new Date().getFullYear();
  const random = Math.floor(100000 + Math.random() * 900000);
  return `QAC${year}-${random}`;
};

export const createOrder = ({ items, summary, address, paymentMethod }) => {
  const orders = loadOrders();

  const order = {
    id: Date.now(),
    invoiceNumber: generateInvoiceNumber(),
    date: new Date().toISOString(),
    status: "Processing",
    paymentMethod,
    items,
    subtotal: summary.subtotal,
    discount: summary.discount,
    delivery: summary.delivery,
    total: summary.totalPayable,
    address,
    estimatedDeliveryDate: new Date(Date.now() + 3 * DAY_IN_MS).toISOString(),
  };

  const updatedOrders = [order, ...orders];
  saveOrders(updatedOrders);
  localStorage.setItem(LATEST_ORDER_KEY, String(order.id));

  return withDerivedOrderData(order);
};

export const getLatestOrder = () => {
  const latestOrderId = localStorage.getItem(LATEST_ORDER_KEY);

  if (!latestOrderId) {
    return null;
  }

  return loadOrders().find((order) => String(order.id) === String(latestOrderId)) || null;
};

export const getOrderByInvoiceNumber = (invoiceNumber) =>
  loadOrders().find(
    (order) => String(order.invoiceNumber).toLowerCase() === String(invoiceNumber).toLowerCase()
  ) || null;

export const getOrderById = (orderId) =>
  loadOrders().find((order) => String(order.id) === String(orderId)) || null;
